import React from 'react';
import { Rate, Tooltip } from 'antd';
import DOMPurify from 'dompurify';
import styles from './NoteRate.module.css';

const NoteRate = ({ rate, lastMessage, label = 'Note globale', compact = false }) => {
  const note = lastMessage?.messageUpdateStatut?.note;
  const hasRate = rate != null && rate > 0;
  const hasNote = note && note.trim() !== '';

  if (!hasRate && !hasNote) return null;

  const sanitizedNote = hasNote ? DOMPurify.sanitize(note) : '';

  return (
    <div className={`${styles.wrapper} ${compact ? styles.compact : ''}`}>
      {hasRate && (
        <div
          className={styles.rateBlock}
          role="img"
          aria-label={`${label}: ${rate} sur 5`}
        >
          {!compact && <span className={styles.label}>{label}</span>}
          <Rate
            allowHalf
            value={rate}
            disabled
            className={styles.rate}
          />
          {compact && <span className={styles.rateValue}>{rate.toFixed(1)}</span>}
        </div>
      )}

      {hasNote && (
        <Tooltip
          title={<div dangerouslySetInnerHTML={{ __html: sanitizedNote }} />}
          placement="bottom"
          arrow
          overlayStyle={{ maxWidth: 320 }}
        >
          <div
            className={styles.noteContent}
            dangerouslySetInnerHTML={{ __html: sanitizedNote }}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default React.memo(NoteRate);